<template>
	<div>
		<!-- Cabecera -->
		<pm-header>
			<template slot="contenido">
				<div class="row h-100 d-flex align-items-center fondo-header m-0">
					<div
						class="col-lg-4 offset-lg-1 col-xl-3 offset-xl-2 d-none d-lg-block"
						data-aos="fade-right"
						data-aos-delay="500"
					>
						<img class="img-fluid" src="@/assets/img-pub/Difarmer-nosotros.png" />
					</div>
					<div
						class="col-12 col-sm-10 offset-sm-1 col-lg-6 col-xl-5 text-center text-lg-left text-white"
						data-aos="fade-left"
						data-aos-delay="750"
					>
						<p class="fuente-header-titulo p-0 m-0">Nuestro trabajo</p>
						<p class="fuente-header-subtitulo p-0 m-0">habla por nosotros.</p>
					</div>
				</div>
			</template>
		</pm-header>

		<!-- Historia -->
		<div class="row p-0 m-0 pt-4 pt-lg-5 pb-lg-3">
			<div class="col-12 col-md-6 col-xl-5 offset-xl-2 d-flex align-items-center">
				<div data-aos="fade-right">
					<p class="fuente-historia-titulo">Una historia de trabajo y esfuerzo, que ha rendido frutos...</p>
					<p class="fuente-historia-texto p-0 m-0 mt-2 mb-2">
						Difarmer, una empresa familiar, tiene sus inicios en 1960 en la ciudad de Culiacán, Sinaloa, México.
						Don Timoteo López Zepeda, con más de 20 años de experiencia en el ramo farmacéutico, decidió emprender y fundar su propio negocio de distribución de medicamentos.
						Con un correcto manejo y una gran dedicación a traves de los años, el negocio prosperó y delegó a sus hijos la empresa.
					</p>
				</div>
			</div>
			<div
				class="col-8 offset-2 col-md-6 offset-md-0 col-xl-3 d-sm-flex align-items-center d-none"
				data-aos="fade-left"
			>
				<img class="img-fluid" src="@/assets/img-pub/Ilustraciones-Difarmer-1.jpg" />
			</div>
		</div>
		<div class="row p-0 m-0 pt-lg-5 pb-lg-3">
			<div
				class="col-8 offset-2 col-md-6 offset-md-0 col-xl-3 offset-xl-2 d-sm-flex align-items-center d-none"
				data-aos="fade-right"
				data-aos-delay="500"
			>
				<img class="img-fluid" src="@/assets/img-pub/Ilustraciones-Difarmer-2.jpg" />
			</div>
			<div
				class="col-12 col-md-6 col-xl-5 d-flex align-items-center"
				data-aos="fade-left"
				data-aos-delay="500"
			>
				<p
					class="fuente-historia-texto p-0 m-0 mt-2 mb-2"
				>En 1993 derivado de esta iniciativa, surgieron dos sociedades del ramo farmacéutico, entre ellas DIFARMER, la cual se expandió primeramente en el noroeste del país, y gracias a la experiencia, trabajo en equipo y la inversión en nuevas tecnologías, hoy se ha logrado un lugar destacado en la distribución farmacéutica con una cobertura nacional.</p>
			</div>
		</div>
		<div class="row p-0 m-0 pb-5 pt-lg-5 pb-lg-3">
			<div
				class="col-12 col-md-6 col-xl-5 offset-xl-2 d-flex align-items-center"
				data-aos="fade-right"
				data-aos-delay="500"
			>
				<p
					class="fuente-historia-texto p-0 m-0 mt-2 mb-2"
				>Con 6 centros de distribución en todo el país, generando empleo a cientos de familias mexicanas y apostando por la mejora continua, Difarmer ha logrado la distinción y especialización logística en la distribución de insumos para la salud, buscando siempre exceder las expectativas de sus clientes, garantizando calidad en todos sus productos y ofreciendo el mejor de los servicio.</p>
			</div>
			<div
				class="contenedor col-8 offset-2 col-md-6 offset-md-0 col-xl-3 d-flex align-items-center"
				data-aos="fade-left"
				data-aos-delay="500"
			>
				<img class="img-fluid" src="@/assets/img-pub/cedis.jpg" />
			</div>
		</div>

		<!-- Valores -->
		<div class="row p-0 m-0 fondo-valores pt-3">
			<div class="col-12 col-xl-8 offset-xl-2">
				<div data-aos="fade-right">
					<p class="p-0 m-0 pb-2 fuente-valores-titulo">Forjados con 4 valores</p>
				</div>
			</div>

			<div class="col-12 col-md-6 col-xl-4 offset-xl-2">
				<div data-aos="fade-up" data-aos-delay="500">
					<p class="p-0 m-0 pb-2 fuente-valores-subtitulo">Integridad</p>
					<p
						class="fuente-valores-texto"
					>Basamos en el respeto, honestidad y responsabilidad nuestras actitudes, conductas y comportamiento, estableciendo sanas relaciones sociales con clientes, proveedores, compañeros de trabajo y sociedad en general. Somos coherentes entre nuestros pensamientos, declaraciones y acciones.</p>
				</div>
			</div>
			<div class="col-12 col-md-6 col-xl-4">
				<div data-aos="fade-up" data-aos-delay="800">
					<p class="p-0 m-0 pb-2 fuente-valores-subtitulo">Servicio</p>
					<p
						class="fuente-valores-texto"
					>Actuamos enfocados a lograr la satisfacción de nuestros clientes internos y externos, ocupándonos en brindarle una atención de calidad y una respuesta oportuna a sus necesidades.</p>
				</div>
			</div>
			<div class="col-12 col-md-6 col-xl-4 offset-xl-2">
				<div data-aos="fade-up" data-aos-delay="1100">
					<p class="p-0 m-0 pb-2 fuente-valores-subtitulo">Innovaci&oacute;n</p>
					<p
						class="fuente-valores-texto"
					>Participamos en la transformación del mercado mediante la aplicación de tecnologías y sistemas productivos de vanguardia; y de esta forma, proporcionamos a nuestros clientes soluciones innovadoras, a fin de obtener los resultados que aseguren nuestro crecimiento e independencia financiera.</p>
				</div>
			</div>
			<div class="col-12 col-md-6 col-xl-4">
				<div data-aos="fade-up" data-aos-delay="1400">
					<p class="p-0 m-0 pb-2 fuente-valores-subtitulo">Competitividad</p>
					<p
						class="pb-3 fuente-valores-texto"
					>Creemos que la mejora continua es la base para asegurar la permanencia de la empresa, por lo que nos enfocamos en la profesionalización y desarrollo de nuestros colaboradores y procesos, con el fin de garantizar las mejores soluciones a nuestros clientes.</p>
				</div>
			</div>
		</div>

		<!-- Mision -->
		<div class="row-fluid">
			<div class="col-12 d-flex p-0 text-center">
				<img class="img-fluid" src="@/assets/img-pub/Difarmer-mision.png" />
				<span class="textoMision centradoMision">Nuestra misi&oacute;n</span>
				<span
					class="detalleMision centradoDet mt-4"
				>Participamos responsablemente en la cadena de salud de las familias mexicanas.</span>
			</div>
		</div>

		<!-- Vision -->
		<div class="row-fluid px-3 px-xl-0 my-5">
			<div class="col-12 p-0 text-center py-3 py-sm-4 col-xl-8 offset-xl-2">
				<p class="p-0 fuente-vision-titulo">Nuestra visi&oacute;n</p>
				<p
					class="p-0 m-0 fuente-vision-texto"
				>Ser la principal distribuidora de medicamento genérico en el país, contando con almacenes ubicados estratégicamente que sustenten una altamente eficiente red logística, la cual nos permita brindar a nuestros clientes una experiencia de entrega perfecta y ofrecerle gran variedad de productos a precios competitivos. 
				Formaremos líderes que dirijan con responsabilidad y compromiso sus áreas logrando resultados extraordinarios en conjunto con sus colaboradores, todos viviendo la cultura organizacional de la empresa y sus familias beneficiándose de nuestros programas sociales. La rentabilidad de Difarmer será producto de la planeación estratégica, la eficiencia operativa y el incremento sostenido de las ventas.</p>
			</div>
		</div>

		<!-- Oficinas -->
		<div
			class="row-fluid px-3 px-lg-4 px-xl-0 pt-3 pb-2 pt-lg-4 pb-lg-4 fondo-oficinas text-white text-center"
		>
			<!-- <div class="col-12 col-xl-6 offset-xl-3">
				<div class="row pb-2 pb-lg-4" id="nose">
					<a class="col-12 py-4 fondo-oficinas1" href="https://www.google.com.mx/maps/place/Difarmer,+S.A.+de+C.V./@24.7877191,-107.4351683,17z/data=!4m5!3m4!1s0x86bcd05fe1489967:0xa7e43126e94c570f!8m2!3d24.7866428!4d-107.4331942" target="_black">
						<p class="p-0 m-0 fuente-oficinas-titulo">Corporativo Central</p>
						<p class="p-0 m-0 fuente-oficinas-subtitulo">Culiac&aacute;n, Sinaloa</p>
					</a>
				</div>
			</div>-->
			<div class="col-12 col-xl-6 offset-xl-3">
				<div class="row pb-2 pb-lg-4">
					<a
						class="col-12 py-4 fondo-oficinas2"
						href="https://www.google.com.mx/maps/place/Difarmer,+S.A.+de+C.V./@24.7877191,-107.4351683,17z/data=!4m5!3m4!1s0x86bcd05fe1489967:0xa7e43126e94c570f!8m2!3d24.7866428!4d-107.4331942"
						target="_black"
					>
						<p
							class="p-0 m-0 fuente-oficinas-titulo"
						>CEDIS / CORPORATIVO</p>
						<p class="p-0 m-0 fuente-oficinas-subtitulo">Culiac&aacute;n, Sinaloa</p>
					</a>
				</div>
			</div>
			<div class="col-12 col-xl-6 offset-xl-3">
				<div class="row pb-2 pb-lg-4">
					<a
						class="col-12 py-4 fondo-oficinas3"
						href="https://www.google.com/maps/place/Difarmer+-+Torre%C3%B3n/@25.5792465,-103.4419971,17z/data=!3m1!4b1!4m6!3m5!1s0x868fdbf353c11359:0x81dc2af8c9bfca7b!8m2!3d25.5792417!4d-103.4394222!16s%2Fg%2F11ts4bk5d8?authuser=0&entry=ttu"
						target="_black"
					>
						<p class="p-0 m-0 fuente-oficinas-titulo">CEDIS</p>
						<p class="p-0 m-0 fuente-oficinas-subtitulo">Torre&oacute;n, Coahuila</p>
					</a>
				</div>
			</div>
			<div class="col-12 col-xl-6 offset-xl-3">
				<div class="row pb-2 pb-lg-4">
					<a
						class="col-12 py-4 fondo-oficinas4"
						href="https://www.google.com.mx/maps/place/Difarmer,+S.A.+de+C.V./@21.101243,-101.7161961,18z/data=!4m5!3m4!1s0x842bc070ee98bbef:0x13f38528a7617f75!8m2!3d21.1008877!4d-101.7147343"
						target="_black"
					>
						<p class="p-0 m-0 fuente-oficinas-titulo">CEDIS</p>
						<p class="p-0 m-0 fuente-oficinas-subtitulo">Le&oacute;n, Guanajuato</p>
					</a>
				</div>
			</div>
			<div class="col-12 col-xl-6 offset-xl-3">
				<div class="row pb-2">
					<a
						class="col-12 py-4 fondo-oficinas5"
						href="https://www.google.com.mx/maps/place/Difarmer,+S.A.+de+C.V./@19.0609349,-98.1106987,17z/data=!3m1!4b1!4m5!3m4!1s0x85cfeb533a47949f:0x36fd76f8862849c3!8m2!3d19.0609298!4d-98.10851"
						target="_black"
					>
						<p class="p-0 m-0 fuente-oficinas-titulo">CEDIS</p>
						<p class="p-0 m-0 fuente-oficinas-subtitulo">Puebla, Puebla</p>
					</a>
				</div>
			</div>
			<div class="col-12 col-xl-6 offset-xl-3">
				<div class="row pb-2">
					<a
						class="col-12 py-4 fondo-oficinas6"
						href="https://www.google.com.mx/maps/place/Difarmer,+S.A+de+C.V/@20.5550091,-100.2740838,19z/data=!4m5!3m4!1s0x85d35d18853a2ecf:0x93cc4793e9056f60!8m2!3d20.5551281!4d-100.2735728"
						target="_black"
					>
						<p class="p-0 m-0 fuente-oficinas-titulo">CEDIS</p>
						<p class="p-0 m-0 fuente-oficinas-subtitulo">Querétaro, Qro</p>
					</a>
				</div>
			</div>
			<div class="col-12 col-xl-6 offset-xl-3">
				<div class="row pb-2">
					<a
						class="col-12 py-4 fondo-oficinas7"
						href="https://www.google.com/maps/place/Difarmer,+S.A.+de+C.V./@32.6364812,-115.2768132,15z/data=!4m5!3m4!1s0x0:0x95c6eb53227bd268!8m2!3d32.6364812!4d-115.2768132"
						target="_black"
					>
						<p class="p-0 m-0 fuente-oficinas-titulo">CEDIS</p>
						<p class="p-0 m-0 fuente-oficinas-subtitulo">Mexicali, B.C.</p>
					</a>
				</div>
			</div>
		</div>

		<!-- Pie pagina -->
		<pm-pie-pagina></pm-pie-pagina>
	</div>
</template>

<script>
	import PmHeader from "@/components/publica/Header"
	import PmPiePagina from "@/components/publica/PiePagina"
	export default {
		components: {
			PmHeader,
			PmPiePagina
		},
		mounted() {
			//this.ocultarChat()
		}
	}
</script>

<style scoped>
	.contenedor {
		position: relative;
		display: inline-block;
		text-align: center;
	}
	.centradoMision {
		position: absolute;
		top: 40%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	.centradoDet {
		width: 750px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	/* Cabecera */
	.fondo-header {
		/* background-image: url(""); */
		background-repeat: no-repeat, repeat;
		background-size: cover;
		background-position: center;
	}
	.fuente-header-titulo {
		font-weight: 600;
		color: var(--color-blanco);
	}
	.fuente-header-subtitulo {
		color: var(--color-blanco);
	}
	/* Historia */
	.fuente-historia-titulo {
		font-weight: 600;
		font-family: "Poppins", sans-serif;
		font-style: italic;
		color: var(--color-amarillo);
	}
	.fuente-historia-texto {
		font-family: "Open Sans", sans-serif;
		color: var(--color-gris-dark);
	}
	/* Valores */
	.fondo-valores {
		background-color: var(--color-gris-light);
	}
	.fuente-valores-titulo {
		font-family: "Poppins", sans-serif;
		font-weight: 600;
		font-style: italic;
		color: var(--color-amarillo);
	}
	.fuente-valores-subtitulo {
		font-family: "Open Sans", sans-serif;
		font-weight: bold;
		font-style: italic;
		color: var(--color-azul-light);
	}
	.fuente-valores-texto {
		font-family: "Open Sans", sans-serif;
		color: var(--color-gris-dark);
	}
	/* Vision */
	.fuente-vision-titulo {
		color: var(--color-azul-light);
	}
	.fuente-vision-texto {
		/*font-style: italic;*/
		color: var(--color-azul-light);
	}
	/* Oficinas */
	.fondo-oficinas {
		background-color: var(--color-azul-dark);
	}
	.fondo-oficinas1 {
		background-image: url("../../assets/img-pub/CEDIS-CULIACAN.png");
		background-position: center;
		background-repeat: no-repeat, repeat;
		background-size: 100% 100%;
		-webkit-transition: background-size 1s ease;
		-moz-transition: background-size 1s ease;
		-o-transition: background-size 1s ease;
		-ms-transition: background-size 1s ease;
		transition: background-size 1s ease;
		cursor: pointer;
		text-decoration: none;
		color: #fff;
	}
	.fondo-oficinas1:hover {
		background-position: center;
		background-size: 105% 105%;
	}
	.fondo-oficinas2 {
		background-image: url("../../assets/img-pub/CEDIS-CULIACAN.png");
		background-position: center;
		background-repeat: no-repeat, repeat;
		background-size: 100% 100%;
		-webkit-transition: background-size 1s ease;
		-moz-transition: background-size 1s ease;
		-o-transition: background-size 1s ease;
		-ms-transition: background-size 1s ease;
		transition: background-size 1s ease;
		cursor: pointer;
		text-decoration: none;
		color: #fff;
	}
	.fondo-oficinas2:hover {
		background-position: center;
		background-size: 105% 105%;
	}
	.fondo-oficinas3 {
		background-image: url("../../assets/img-pub/CEDIS-TORREON.png");
		background-position: center;
		background-repeat: no-repeat, repeat;
		background-size: 100% 100%;
		-webkit-transition: background-size 1s ease;
		-moz-transition: background-size 1s ease;
		-o-transition: background-size 1s ease;
		-ms-transition: background-size 1s ease;
		transition: background-size 1s ease;
		cursor: pointer;
		text-decoration: none;
		color: #fff;
	}
	.fondo-oficinas3:hover {
		background-position: center;
		background-size: 105% 105%;
	}
	.fuente-oficinas-titulo {
		font-weight: 600;
	}
	.fondo-oficinas4 {
		background-image: url("../../assets/img-pub/CEDIS-LEON.png");
		background-position: center;
		background-repeat: no-repeat, repeat;
		background-size: 100% 100%;
		-webkit-transition: background-size 1s ease;
		-moz-transition: background-size 1s ease;
		-o-transition: background-size 1s ease;
		-ms-transition: background-size 1s ease;
		transition: background-size 1s ease;
		cursor: pointer;
		text-decoration: none;
		color: #fff;
	}
	.fondo-oficinas4:hover {
		background-position: center;
		background-size: 105% 105%;
	}
	.fondo-oficinas5 {
		background-image: url("../../assets/img-pub/CEDIS-PUEBLA.png");
		background-position: center;
		background-repeat: no-repeat, repeat;
		background-size: 100% 100%;
		-webkit-transition: background-size 1s ease;
		-moz-transition: background-size 1s ease;
		-o-transition: background-size 1s ease;
		-ms-transition: background-size 1s ease;
		transition: background-size 1s ease;
		cursor: pointer;
		text-decoration: none;
		color: #fff;
	}
	.fondo-oficinas5:hover {
		background-position: center;
		background-size: 105% 105%;
	}
	.fondo-oficinas6 {
		background-image: url("../../assets/img-pub/CEDIS-QUERETARO.png");
		background-position: center;
		background-repeat: no-repeat, repeat;
		background-size: 100% 100%;
		-webkit-transition: background-size 1s ease;
		-moz-transition: background-size 1s ease;
		-o-transition: background-size 1s ease;
		-ms-transition: background-size 1s ease;
		transition: background-size 1s ease;
		cursor: pointer;
		text-decoration: none;
		color: #fff;
	}
	.fondo-oficinas6:hover {
		background-position: center;
		background-size: 105% 105%;
	}

	.fondo-oficinas7 {
		background-image: url("../../assets/img-pub/Cedis-Mexicali.jpg");
		background-position: center;
		background-repeat: no-repeat, repeat;
		background-size: 100% 100%;
		-webkit-transition: background-size 1s ease;
		-moz-transition: background-size 1s ease;
		-o-transition: background-size 1s ease;
		-ms-transition: background-size 1s ease;
		transition: background-size 1s ease;
		cursor: pointer;
		text-decoration: none;
		color: #fff;
	}
	.fondo-oficinas7:hover {
		background-position: center;
		background-size: 105% 105%;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.centradoMision {
			position: absolute;
			top: 30%;
			left: 50%;
			transform: translate(-50%, -50%);
		}

		.centradoDet {
			width: 300px;
			position: absolute;
			top: 40%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
		.textoMision {
			position: absolute;
			text-align: center;
			font-family: "Poppins", sans-serif;
			font-size: 12px;
			letter-spacing: 0.7px;
			color: #ffffff;
		}

		.detalleMision {
			position: absolute;
			text-align: center;
			font-family: "Poppins", sans-serif;
			font-style: italic;
			font-weight: 600;
			font-size: 14px;
			color: #ffffff;
		}
		/* Cabecera */
		.fondo-header {
			background-image: url("../../assets/img-pub/Nosotros 576px.png");
		}
		.fuente-header-titulo {
			font-size: 30px !important;
		}
		.fuente-header-subtitulo {
			font-size: 28px !important;
		}
		/* Historia */
		.fuente-historia-titulo {
			font-size: 20px !important;
		}
		.fuente-historia-texto {
			font-size: 14px !important;
		}
		/* Valores */
		.fuente-valores-titulo {
			font-size: 20px !important;
		}
		.fuente-valores-subtitulo {
			font-size: 20px !important;
		}
		.fuente-valores-texto {
			font-size: 14px !important;
		}
		/* Vision */
		.fuente-vision-titulo {
			font-size: 20px !important;
		}
		.fuente-vision-texto {
			font-size: 14px !important;
		}
		/* Oficinas */
		.fuente-oficinas-titulo {
			font-size: 14px !important;
		}
		.fuente-oficinas-subtitulo {
			font-size: 14px !important;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.centradoMision {
			position: absolute;
			top: 45%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
		.centradoDet {
			width: 450px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
		.textoMision {
			position: absolute;
			text-align: center;
			font-family: "Poppins", sans-serif;
			font-size: 14px;
			letter-spacing: 0.9px;
			color: #ffffff;
		}

		.detalleMision {
			position: absolute;
			text-align: center;
			font-family: "Poppins", sans-serif;
			font-style: italic;
			font-weight: 600;
			font-size: 18px;
			letter-spacing: 0.9px;
			color: #ffffff;
		}
		/* Cabecera */
		.fondo-header {
			background-image: url("../../assets/img-pub/Nosotros 576px.png");
		}
		.fuente-header-titulo {
			font-size: 43px !important;
		}
		.fuente-header-subtitulo {
			font-size: 43px !important;
		}
		/* Historia */
		.fuente-historia-titulo {
			font-size: 20px !important;
		}
		.fuente-historia-texto {
			font-size: 16px !important;
		}
		/* Valores */
		.fuente-valores-titulo {
			font-size: 20px !important;
		}
		.fuente-valores-subtitulo {
			font-size: 20px !important;
		}
		.fuente-valores-texto {
			font-size: 16px !important;
		}
		/* Vision */
		.fuente-vision-titulo {
			font-size: 20px !important;
		}
		.fuente-vision-texto {
			font-size: 16px !important;
		}
		/* Oficinas */
		.fuente-oficinas-titulo {
			font-size: 16px !important;
		}
		.fuente-oficinas-subtitulo {
			font-size: 16px !important;
		}
		/*  */
		.d-none {
			display: none !important;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		/*Nuestra mision*/
		.centradoMision {
			position: absolute;
			top: 35%;
			left: 50%;
			transform: translate(-50%, -50%);
		}

		.centradoDet {
			width: 650px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
		.textoMision {
			position: absolute;
			text-align: center;
			font-family: "Poppins", sans-serif;
			font-size: 14px;
			letter-spacing: 0.9px;
			color: #ffffff;
		}

		.detalleMision {
			position: absolute;
			text-align: center;
			font-family: "Poppins", sans-serif;
			font-style: italic;
			font-weight: 600;
			font-size: 24px;
			letter-spacing: 0.9px;
			color: #ffffff;
		}
		/* Cabecera */
		.fondo-header {
			background-image: url("../../assets/img-pub/Nosotros 768px.png");
		}
		.fuente-header-titulo {
			font-size: 43px !important;
		}
		.fuente-header-subtitulo {
			font-size: 43px !important;
		}
		/* Historia */
		.fuente-historia-titulo {
			font-size: 20px !important;
		}
		.fuente-historia-texto {
			font-size: 16px !important;
		}
		/* Valores */
		.fuente-valores-titulo {
			font-size: 20px !important;
		}
		.fuente-valores-subtitulo {
			font-size: 20px !important;
		}
		.fuente-valores-texto {
			font-size: 16px !important;
		}
		/* Vision */
		.fuente-vision-titulo {
			font-size: 20px !important;
		}
		.fuente-vision-texto {
			font-size: 16px !important;
		}
		/* Oficinas */
		.fuente-oficinas-titulo {
			font-size: 20px !important;
		}
		.fuente-oficinas-subtitulo {
			font-size: 20px !important;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		/*Nuestra mision*/
		.centradoDet {
			width: 750px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
		.textoMision {
			position: absolute;
			text-align: center;
			font-family: "Poppins", sans-serif;
			font-size: 18px;
			letter-spacing: 0.9px;
			color: #ffffff;
		}

		.detalleMision {
			position: absolute;
			text-align: center;
			font-family: "Poppins", sans-serif;
			font-style: italic;
			font-weight: 600;
			font-size: 32px;
			letter-spacing: 0.9px;
			color: #ffffff;
		}

		/* Cabecera */
		.fuente-header-titulo {
			font-size: 43px !important;
		}
		.fuente-header-subtitulo {
			font-size: 43px !important;
		}
		/* Historia */
		.fuente-historia-titulo {
			font-size: 28px !important;
		}
		.fuente-historia-texto {
			font-size: 18px !important;
		}
		/* Valores */
		.fuente-valores-titulo {
			font-size: 28px !important;
		}
		.fuente-valores-subtitulo {
			font-size: 28px !important;
		}
		.fuente-valores-texto {
			font-size: 18px !important;
		}
		/* Vision */
		.fuente-vision-titulo {
			font-size: 28px !important;
		}
		.fuente-vision-texto {
			font-size: 18px !important;
		}
		/* Oficinas */
		.fuente-oficinas-titulo {
			font-size: 24px !important;
		}
		.fuente-oficinas-subtitulo {
			font-size: 24px !important;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		.centradoMision {
			position: absolute;
			top: 43%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
		.centradoDet {
			width: 950px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
		.textoMision {
			position: absolute;
			text-align: center;
			font-family: "Poppins", sans-serif;
			font-size: 18px;
			letter-spacing: 0.9px;
			color: #ffffff;
		}

		.detalleMision {
			position: absolute;
			text-align: center;
			font-family: "Poppins", sans-serif;
			font-style: italic;
			font-weight: 600;
			font-size: 32px;
			letter-spacing: 0.9px;
			color: #ffffff;
		}
		/* Cabecera */
		.fuente-header-titulo {
			font-size: 55px !important;
		}
		.fuente-header-subtitulo {
			font-size: 50px !important;
		}
		/* Historia */
		.fuente-historia-titulo {
			font-size: 32px !important;
		}
		.fuente-historia-texto {
			font-size: 20px !important;
		}
		/* Valores */
		.fuente-valores-titulo {
			font-size: 32px !important;
		}
		.fuente-valores-subtitulo {
			font-size: 32px !important;
		}
		.fuente-valores-texto {
			font-size: 20px !important;
		}
		/* Vision */
		.fuente-vision-titulo {
			font-size: 32px !important;
		}
		.fuente-vision-texto {
			font-size: 20px !important;
		}
		/* Oficinas */
		.fuente-oficinas-titulo {
			font-size: 28px !important;
		}
		.fuente-oficinas-subtitulo {
			font-size: 28px !important;
		}
	}
</style>